import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isLowFrequency(gameType: string) {
  return ["1070", "10010", "10011", "10012", "10013"].includes(gameType);
}

function isMarbleGame(roomId: string) {
  return ["60301", "60303", "60201", "60304", "60305"].includes(roomId);
}

export function getGameIconType(gameType: string, roomId: string): string {
  switch (gameType) {
    case "1062":
      return isMarbleGame(roomId) ? "marble" : gameType;
    default:
      return gameType;
  }
}
